import React , {useEffect}from "react";
import { GetProfileImages } from "../../DocumentDetails/slice";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ProfileAndBannerImage from "./ProfileAndBannerImage";
import {
  DEFAULT_AVATAR_URL,
  DEFAULT_COVER_URL,
  EntityType,
} from "../../../common/enum";
import Input from "./Input";
import { useDispatch, useSelector } from "react-redux";
import {
  getDonationById,
  getDonationEntityDetailById,
  getReceiverDetailById,
} from "../slice";
import Messages from "./Messages";

const ChatPanel = ({
  chatUid,
  entityDonation,
  particularChatDonation,
  component,
  collection,
  chatdrawerState,
  toggleChatDrawer,
  t,
}) => {
  const dispatch = useDispatch();
  const [lastMessageDate, setLastMessageDate] = React.useState();
  const [chatInputUid, setChatInputUid] = React.useState();
  const {
    dashboardInfo: { entityProfileSelect },
    auth: { profile },
    messageReducer: { chatDonationDetail, recevierEntityDetail },
  } = useSelector((state) => state);

  React.useEffect(() => {
    let payload = {};
    if (collection !== undefined && Object.keys(collection).length > 0) {
      payload["donationId"] = collection?.collection?.donationId;
    } else if (particularChatDonation !== undefined) {
      payload["donationId"] = particularChatDonation?.donationId;
    }
    if (Object.keys(payload).length > 0) {
      dispatch(getDonationById(payload))
        .unwrap()
        .then((res) => {
          dispatch(
            getDonationEntityDetailById({
              entityId: res.donationId.donations.donation.entityId,
            })
          );
          let entityPayload = {};
          if (collection?.collection.collectorId === profile?.entity.entityId) {
            entityPayload["entityId"] =
              res.donationId.donations.donation.entityId;
          } else {
            entityPayload["entityId"] =
              entityDonation !== undefined
                ? entityDonation.entityId
                : collection?.collection.collectorId;
          }
          dispatch(getReceiverDetailById(entityPayload));
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  }, [dispatch, collection, profile, particularChatDonation]);

const [entitybanneruri, setEntityBannerUri] = React.useState("");
const [profilepictureuri, setProfilePictureUri] = React.useState("");

useEffect(() => {
  const entity = recevierEntityDetail?.entity;
  if (!entity) return;

  const isValidImage = (img) => !!img && img !== "string";

  if (isValidImage(entity.bannerImage)) {
    dispatch(GetProfileImages(entity.bannerImage))
      .unwrap()
      .then((response) => {
        if(response.isActive != null){
            setEntityBannerUri(response.isActive);
          }else{
            setEntityBannerUri(DEFAULT_COVER_URL);
          }
      })
      .catch((err) => {
        console.warn("Erro ao carregar banner image:", err);
      });
  }

  if (isValidImage(entity.profilePicture)) {
    dispatch(GetProfileImages(entity.profilePicture))
      .unwrap()
      .then((response) => {
          if(response.isActive != null){
            setProfilePictureUri(response.isActive);
          }else{
            setProfilePictureUri(DEFAULT_AVATAR_URL);
          }

      })
      .catch((err) => {
        console.warn("Erro ao carregar profile picture:", err);
      });
  }
}, [recevierEntityDetail, dispatch]);

  return (
    <Drawer
      anchor={"right"}
      open={chatdrawerState}
      onClose={() => toggleChatDrawer(false)}
      PaperProps={{
        sx: {
          width: "50%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        },
      }}
    >
      <Button
        sx={{
          position: "fixed",
          right: "51%",
          top: 10,
          zIndex: 1,
          minWidth: 0,
          padding: "4px",
          borderRadius: "4px",
          backgroundColor: "#ffc3c3",
          "&:hover": {
            backgroundColor: "#ffc3c3",
          },
          "@media (max-width:900px)": {
            right: "1%",
          },
        }}
        onClick={() => toggleChatDrawer(false)}
      >
        <CloseOutlinedIcon color="error" />
      </Button>
      <ProfileAndBannerImage
        bannerImageUrl={
          Object.keys(recevierEntityDetail).length > 0 &&
          recevierEntityDetail?.entity?.bannerImage !== "string" &&
          recevierEntityDetail?.entity?.bannerImage !== null
            ? entitybanneruri
            : DEFAULT_COVER_URL
        }
        profilePictureUrl={
          Object.keys(recevierEntityDetail).length > 0 &&
          recevierEntityDetail?.entity?.profilePicture !== "string" &&
          recevierEntityDetail?.entity?.profilePicture !== null
            ? profilepictureuri
            : DEFAULT_AVATAR_URL
        }
        // entityName={
        //   !recevierEntityDetail?.entity?.isParentEntity &&
        //   recevierEntityDetail?.entity?.isGroupEntity
        //     ? recevierEntityDetail?.address.find(
        //         (address) =>
        //           address?.addressId ===
        //           recevierEntityDetail?.entity?.entityAddressId
        //       )?.addressTitle
        //     : recevierEntityDetail?.entity?.entityName
        // }
        entityName={
          !recevierEntityDetail?.entity?.isParentEntity &&
          recevierEntityDetail?.entity?.isGroupEntity
            ? recevierEntityDetail?.entity?.entityName
            : recevierEntityDetail?.entity?.entityName
        }
        lastMessageDate={
          entityDonation?.date !== undefined
            ? entityDonation?.date.toDate().toLocaleDateString("pt-PT")
            : lastMessageDate !== undefined &&
              lastMessageDate.toDate().toLocaleDateString("pt-PT")
        }
        donationId={
          Object.keys(chatDonationDetail).length > 0
            ? `${new Date(
                chatDonationDetail?.donation?.createdDate
              ).getFullYear()}${chatDonationDetail?.donation.id}`
            : ""
        }
        collectionId={
          particularChatDonation
            ? `${new Date(
                particularChatDonation?.collectionCreatedDate
              ).getFullYear()}${particularChatDonation?.collectionId}`
            : collection !== undefined &&
              `${new Date(collection?.collection?.createdDate).getFullYear()}${
                collection?.collection?.id
              }`
        }
        t={t}
      />
      <Messages
        chatUid={chatUid}
        collection={collection}
        entityDonation={entityDonation}
        setLastMessageDate={setLastMessageDate}
        chatInputUid={chatInputUid}
        t={t}
      />
      <Input
        chatUid={chatUid}
        particularChatDonation={particularChatDonation}
        setChatInputUid={setChatInputUid}
        collection={collection}
        t={t}
      />
    </Drawer>
  );
};

export default ChatPanel;
